export default {
	messages: {
		required: (field) => `This field is required`,
		length: (field) => `The field is poorly formed`,
		max: (field) => `The field is poorly formed`,
		min: (field) => `The field does not have the minimum required length`,
		integer: (field) => `The field is poorly formed`,
		digits: (field) => `The field is poorly formed`,
		regex: (field) => `The field is incorrectly formed, it must be a number`,
		numeric: (field) => `The field is poorly formed`,
		email: (field) => 'The email field is malformed'
	},
	custom : {
		email: {
			required: 'The email field is required',
			email: 'You must provide a valid email address'
		},
		informacionTratamientoDeDatos:{
			required: 'This field is required',
		},
		email_firmante: {
			email: 'You must provide a valid email address'
		},
		telefono: {
			required: 'The telephone field is mandatory',
			length: 'The telephone field is poorly formed',
			min: 'The telephone field is poorly formed',
			max: 'The length of the phone is excessive'
		},
		nombre: {
			required: 'The name field is required'
		},
		mensaje: {
			required: 'The message field is required'
		},
		apellidos: {
			required: 'The last name field is required'
		},
		cif: {
			required: 'The cif field is mandatory',
			length: 'The cif field is poorly formed',
		},
		nombre_usuario: {
			required: 'The username field is required'
		},
		puesto: {
			required: 'The entered field is mandatory'
		},
		telefono: {
			required: 'The telephone field is mandatory',
			length: 'The telephone field is poorly formed',
			min: 'The telephone field is poorly formed',
			max: 'The length of the phone is excessive'
		},
		telefono_empresa: {
			required: 'The telephone field is mandatory',
			length: 'The telephone field is poorly formed',
			min: 'The telephone field is poorly formed',
			max: 'The length of the phone is excessive'
		},
		telefono2: {
			required: 'The telephone field is mandatory',
			length: 'The telephone field is poorly formed',
			min: 'The telephone field is poorly formed',
			max: 'The length of the phone is excessive'
		},
		sede: {
			required: 'The headquarters field is mandatory'
		},
		experiencia: {
			required: 'The experience field is mandatory'
		},
		password: {
			required: 'The password field is required',
			min: 'Password must be at least 8 characters',
			confirmed: 'Passwords do not match',
			digits: 'The password must contain at least one number'
		},
		password2: {
			required: 'The password field is required',
			min: 'Password must be at least 8 characters',
			confirmed: 'Passwords do not match',
			digits: 'The password must contain at least one number'
		},
		politica: {
			required: 'You must accept the privacy policy'
		},
		direccion: {
			required: 'The address field is required'
		},
		cp: {
			required: 'The zip code field is required'
		},
		pais: {
			required: 'The country field is required'
		},
		paiscontacto: {
			required: 'The country field is required'
		},
		file: {
			size: 'The maximum size is 2MB',
			mimes: 'The format must be PDF'
		},
		filePoliza: {
			size: 'The maximum size is 2MB',
			mimes: 'The format must be PDF'
		},
		titulo: {
			required: 'The title field is required'
		},
		plazas: {
			required: 'The number of places field is mandatory'
		},
		poblacion: {
			required: 'The population field is mandatory'
		},
		localidad: {
			required: 'The locality field is mandatory'
		},
		provincia: {
			required: 'The province field is mandatory'
		},
		provinciacontacto: {
			required: 'The province field is mandatory'
		},
		horario: {
			required: 'The work hours field is mandatory'
		},
		horasAldia: {
			required: 'The hours per day field is required',
			numeric: 'The hours per day field must be a numeric value'
		},
		ayudaEstudio: {
			required: 'The remuneration field is mandatory',
			numeric: 'The remuneration field must be a numerical value',
			decimal: 'The remuneration field must be a numerical value'
		},
		meses: {
			between: 'Must be a value between 0 and 12'
		},
		salario: {
			required: 'The remuneration field is mandatory'
		},
		remuneraciones: {
			required: 'The other remuneration field is mandatory'
		},
		tiempoDedicacionJornada: {
			between: 'Must be a value between 0 and 100'
		},
		numeroDiasSemana: {
			between: 'Must be a value between 1 and 7'
		},
		otrasRemuneraciones: {
			required: 'The other remuneration field is mandatory'
		},
		contrato: {
			required: 'The contract type field is required'
		},
		descripcion: {
			required: 'The description field is required'
		},
		curso: {
			required: 'The course field is required'
		},
		titulacion: {
			required: 'The qualification field is mandatory'
		},
		puestoTrabajo: {
			required: 'The job position field is mandatory'
		},
		horasDia: {
			required: 'The hours per day field is required'
		},
		departamento: {
			required: 'The department field is required'
		},
		nombreTutorEmpresa: {
			required: 'The name field of the company tutor is mandatory'
		},
		ApellidosTutorEmpresa: {
			required: 'The last name field of the company tutor is mandatory'
		},
		emailTutorEmpresa: {
			required: 'The email field of the company tutor is mandatory',
			email: 'The email field of the company tutor is incorrectly formed'
		},
		titulacionTutorEmpresa: {
			required: 'The qualification field of the company tutor is mandatory'
		},
		nombreTutorUni: {
			required: 'The name field of the university tutor is mandatory'
		},
		tareasAdesarrollar: {
			required: 'The tasks to be developed field is mandatory'
		},
		nombreFiscal: {
			required: 'The tax name field is mandatory'
		},
		nombreComercial: {
			required: 'The trade name field is required'
		},
		codigo_postal: {
			required: 'The zip code field is required'
		},
		area_funcional: {
			required: 'The functional area field is mandatory'
		},
		nombre_comercial: {
			required: 'The trade name field is required'
		},
		nombre_fiscal: {
			required: 'The tax name field is mandatory'
		},
		listado_titulaciones: {
			required: 'You must choose at least one degree to which the offer is directed'
		},
		privada: {
			required: 'The company type field is required'
		},
		tipoEmpresa: {
			min_value: 'The company type field is mandatory',
			required: 'The company type field is mandatory'
		},
		sector: {
			required: 'The sector field is mandatory'
		},
		startup: {
			required: 'The startup field is required'
		},
		url: {
			url: 'The URL is malformed'
		},
		checkdni: {
			checkdni: "The DNI is poorly formed"
		},
		iban: {
			checkiban: "The IBAN is incorrectly formed"
		},
		urlInscripcionExterna: {
			regex: "The url contains errors"
		},
		linkedin: {
			regex: "The url contains errors"
		},
		nota : {
			between : "The data must be between 1 and 4"
		}
	}
}


// WEBPACK FOOTER //
// ./src/validator/en.js